module.exports = __webpack_public_path__ + "static/pc_rss/img/logo.6c671ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 110
// module chunks = 15